<template>
    <reports></reports>
</template>
<script>
import Reports from '@/components/personal-center/reports.vue';

export default {
  name: 'reports-tabs',
  components: {
    Reports,
  },

};
</script>
<style scoped>
.el-tabs__content{
display: flex;
flex-direction: column;
flex-grow: 1;
height:100%;
}
</style>
